module.exports = __webpack_public_path__ + "img/znxg3.36ad779d.png";